// Mock data for AL-DURAR LAW FIRM website

export const content = {
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'خدماتنا',
      whyUs: 'لماذا نحن',
      contact: 'اتصل بنا',
      consultation: 'احجز استشارة'
    },
    
    // Hero Section
    hero: {
      title: 'مكتب الدرر للمحاماة والاستشارات القانونية',
      subtitle: 'شريككم القانوني الموثوق',
      description: 'نقدم خدمات قانونية واستشارات متخصصة للأفراد والشركات وفق أعلى معايير المهنية والسرية والالتزام.',
      btnPrimary: 'احجز استشارة',
      btnSecondary: 'تواصل معنا'
    },
    
    // About Section
    about: {
      title: 'من نحن',
      content: 'مكتب الدرر للمحاماة والاستشارات القانونية مكتب متخصص في تقديم الخدمات القانونية والاستشارات الاحترافية للأفراد والشركات.\n\nنسعى إلى تقديم حلول قانونية فعالة تحمي مصالح عملائنا وتدعم نجاحهم من خلال فريق يتمتع بالخبرة والكفاءة والالتزام المهني.'
    },
    
    // Management Team Section
    management: {
      badge: 'الهيئة الإدارية',
      title: 'الهيئة الإدارية',
      subtitle: 'نخبة من الخبرات القانونية والإدارية لقيادة المكتب وتقديم أفضل الخدمات القانونية لعملائنا.',
      viewProfileBtn: 'عرض السيرة المهنية الكاملة',
      profile: {
        name: 'محمد علي محمد الحبيب',
        title: 'محامٍ أمام محكمة التمييز | محكم معتمد | مؤسس ومدير عام مكتب الدرر للمحاماة والاستشارات القانونية',
        summary: 'يتمتع الأستاذ محمد علي محمد الحبيب بخبرة مهنية تتجاوز 19 عاماً في المجالات القانونية والمصرفية والإدارية. شملت مسيرته المهنية العمل في وزارة العدل والبنك التجاري الكويتي قبل تأسيس مكتب الدرر للمحاماة والاستشارات القانونية عام 2019.\n\nيمتلك خبرة واسعة في التقاضي أمام مختلف درجات المحاكم، وصياغة العقود والاتفاقيات، وتقديم الاستشارات القانونية للأفراد والشركات، بالإضافة إلى التحكيم وتسوية المنازعات.',
        qualifications: [
          'محامٍ مقيد أمام محكمة التمييز – دولة الكويت',
          'محكم معتمد لدى مركز تحكيم جمعية المحامين الكويتية',
          'رقم القيد: 934',
          'بكالوريوس في الحقوق – جامعة العلوم التطبيقية، مملكة البحرين'
        ],
        expertise: [
          'التقاضي وإدارة القضايا',
          'صياغة العقود والاتفاقيات',
          'التحكيم وتسوية المنازعات',
          'الاستشارات القانونية للشركات والأفراد',
          'التفاوض وإدارة النزاعات'
        ]
      },
      fullProfile: {
        education: 'بكالوريوس في الحقوق – جامعة العلوم التطبيقية، مملكة البحرين',
        registrations: [
          'محامٍ مقيد أمام محكمة التمييز – دولة الكويت',
          'محكم معتمد لدى مركز تحكيم جمعية المحامين الكويتية',
          'رقم القيد: 934'
        ],
        experience: [
          {
            title: 'مؤسس ومدير عام - مكتب الدرر للمحاماة والاستشارات القانونية',
            period: '2019 - حتى الآن',
            description: 'تأسيس وإدارة مكتب متخصص في تقديم الخدمات القانونية الشاملة للأفراد والشركات'
          },
          {
            title: 'البنك التجاري الكويتي',
            period: 'سنوات متعددة',
            description: 'خبرة في المجال المصرفي والعمليات المالية القانونية'
          },
          {
            title: 'وزارة العدل - دولة الكويت',
            period: 'سنوات متعددة',
            description: 'خبرة قضائية وقانونية في المجال الحكومي'
          }
        ],
        skills: [
          'التقاضي أمام محكمة التمييز',
          'صياغة ومراجعة العقود',
          'التحكيم التجاري',
          'تسوية المنازعات',
          'الاستشارات القانونية المتخصصة',
          'إدارة القضايا المعقدة'
        ],
        languages: [
          'العربية - اللغة الأم',
          'الإنجليزية - متقدم'
        ]
      }
    },
    
    // Services Section
    services: {
      title: 'خدماتنا القانونية',
      subtitle: 'نقدم مجموعة شاملة من الخدمات القانونية المتخصصة',
      items: [
        {
          id: 1,
          title: 'الاستشارات القانونية',
          description: 'استشارات قانونية شاملة للأفراد والشركات في جميع المجالات'
        },
        {
          id: 2,
          title: 'القضايا التجارية',
          description: 'تمثيل قانوني متخصص في النزاعات والقضايا التجارية'
        },
        {
          id: 3,
          title: 'تأسيس الشركات',
          description: 'خدمات متكاملة لتأسيس وتسجيل الشركات بمختلف أنواعها'
        },
        {
          id: 4,
          title: 'صياغة ومراجعة العقود',
          description: 'صياغة ومراجعة العقود والاتفاقيات القانونية بدقة عالية'
        },
        {
          id: 5,
          title: 'القضايا المدنية',
          description: 'تمثيل قانوني في جميع أنواع القضايا المدنية'
        },
        {
          id: 6,
          title: 'القضايا العمالية',
          description: 'حلول قانونية متخصصة في قضايا العمل والعمال'
        },
        {
          id: 7,
          title: 'التحكيم وتسوية النزاعات',
          description: 'خدمات التحكيم والوساطة لحل النزاعات بطرق ودية'
        },
        {
          id: 8,
          title: 'تحصيل الديون',
          description: 'خدمات قانونية متخصصة في تحصيل الديون والمستحقات'
        }
      ]
    },
    
    // Why Choose Us
    whyUs: {
      title: 'لماذا تختار مكتب الدرر',
      subtitle: 'نحن نفخر بتقديم خدمات قانونية متميزة',
      items: [
        {
          id: 1,
          title: 'خبرة قانونية متخصصة',
          description: 'فريق من المحامين ذوي الخبرة الواسعة في مختلف المجالات القانونية'
        },
        {
          id: 2,
          title: 'التزام بالمهنية والسرية',
          description: 'نحافظ على سرية معلومات عملائنا ونلتزم بأعلى معايير المهنية'
        },
        {
          id: 3,
          title: 'حلول قانونية فعالة',
          description: 'نقدم حلولاً قانونية مبتكرة وفعالة تحقق أفضل النتائج'
        },
        {
          id: 4,
          title: 'متابعة مستمرة للقضايا',
          description: 'نتابع قضايا عملائنا بشكل دقيق ونبقيهم على اطلاع مستمر'
        },
        {
          id: 5,
          title: 'خدمة احترافية عالية الجودة',
          description: 'نسعى دائماً لتقديم خدمات تفوق توقعات عملائنا'
        }
      ]
    },
    
    // Consultation Form
    consultation: {
      title: 'احجز استشارتك القانونية',
      subtitle: 'املأ النموذج وسنتواصل معك في أقرب وقت',
      form: {
        name: 'الاسم الكامل',
        phone: 'رقم الهاتف',
        email: 'البريد الإلكتروني',
        service: 'نوع الخدمة القانونية',
        message: 'رسالتك',
        submit: 'إرسال الطلب',
        selectService: 'اختر الخدمة'
      },
      success: 'تم إرسال طلبك بنجاح! سنتواصل معك قريباً.',
      error: 'حدث خطأ. يرجى المحاولة مرة أخرى.'
    },
    
    // Contact Section
    contact: {
      title: 'تواصل معنا',
      subtitle: 'نحن هنا لخدمتك',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      location: 'الموقع',
      hours: 'ساعات العمل',
      hoursDetail: 'الأحد - الخميس\n8:00 صباحاً - 4:00 مساءً',
      locationDetail: 'دولة الكويت',
      getInTouch: 'ابقى على تواصل'
    },
    
    // Footer
    footer: {
      description: 'خدمات قانونية احترافية مكرسة لحماية حقوقك ودعم نجاحك.',
      copyright: '© 2026 مكتب الدرر للمحاماة. جميع الحقوق محفوظة.',
      quickLinks: 'روابط سريعة'
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      whyUs: 'Why Us',
      contact: 'Contact',
      consultation: 'Book Consultation'
    },
    
    // Hero Section
    hero: {
      title: 'AL-DURAR LAW FIRM',
      subtitle: 'Your Trusted Legal Partner',
      description: 'Providing professional legal services and strategic legal solutions for individuals and corporations.',
      btnPrimary: 'Book Consultation',
      btnSecondary: 'Contact Us'
    },
    
    // About Section
    about: {
      title: 'About Us',
      content: 'Al-Durar Law Firm provides comprehensive legal services and professional legal consultation for individuals and corporations.\n\nOur mission is to protect our clients\' interests through legal excellence, professionalism, integrity and confidentiality.'
    },
    
    // Management Team Section
    management: {
      badge: 'Management Team',
      title: 'Leadership & Management',
      subtitle: 'Elite legal and administrative leadership dedicated to delivering exceptional legal services and protecting our clients\' interests.',
      viewProfileBtn: 'View Full Professional Profile',
      profile: {
        name: 'Mohammed Ali Mohammed Al-Habeeb',
        title: 'Attorney Before Court of Cassation | Certified Arbitrator | Founder & CEO of AL-DURAR LAW FIRM',
        summary: 'Mr. Mohammed Ali Mohammed Al-Habeeb brings over 19 years of professional experience in legal, banking, and administrative fields. His career included work at the Ministry of Justice and Kuwait Commercial Bank before founding Al-Durar Law Firm for Legal Consultation in 2019.\n\nHe possesses extensive experience in litigation before various court levels, contract drafting and agreements, providing legal consultations to individuals and companies, as well as arbitration and dispute resolution.',
        qualifications: [
          'Attorney registered before the Court of Cassation – State of Kuwait',
          'Certified Arbitrator at the Kuwait Bar Association Arbitration Center',
          'Registration Number: 934',
          'Bachelor of Laws – Applied Science University, Kingdom of Bahrain'
        ],
        expertise: [
          'Litigation & Case Management',
          'Contract Drafting & Agreements',
          'Arbitration & Dispute Resolution',
          'Legal Consultation for Corporations & Individuals',
          'Negotiation & Conflict Management'
        ]
      },
      fullProfile: {
        education: 'Bachelor of Laws – Applied Science University, Kingdom of Bahrain',
        registrations: [
          'Attorney registered before the Court of Cassation – State of Kuwait',
          'Certified Arbitrator at the Kuwait Bar Association Arbitration Center',
          'Registration Number: 934'
        ],
        experience: [
          {
            title: 'Founder & CEO - AL-DURAR LAW FIRM',
            period: '2019 - Present',
            description: 'Established and managing a specialized firm providing comprehensive legal services to individuals and corporations'
          },
          {
            title: 'Kuwait Commercial Bank',
            period: 'Multiple Years',
            description: 'Experience in banking sector and legal financial operations'
          },
          {
            title: 'Ministry of Justice - State of Kuwait',
            period: 'Multiple Years',
            description: 'Judicial and legal experience in governmental sector'
          }
        ],
        skills: [
          'Litigation Before Court of Cassation',
          'Contract Drafting & Review',
          'Commercial Arbitration',
          'Dispute Resolution',
          'Specialized Legal Consultation',
          'Complex Case Management'
        ],
        languages: [
          'Arabic - Native',
          'English - Advanced'
        ]
      }
    },
    
    // Services Section
    services: {
      title: 'Our Legal Services',
      subtitle: 'Comprehensive legal solutions tailored to your needs',
      items: [
        {
          id: 1,
          title: 'Legal Consultation',
          description: 'Expert legal advice for individuals and businesses across all practice areas'
        },
        {
          id: 2,
          title: 'Commercial Law',
          description: 'Specialized representation in commercial disputes and litigation'
        },
        {
          id: 3,
          title: 'Company Formation',
          description: 'Complete services for establishing and registering companies'
        },
        {
          id: 4,
          title: 'Contract Drafting & Review',
          description: 'Precise drafting and comprehensive review of legal contracts'
        },
        {
          id: 5,
          title: 'Civil Litigation',
          description: 'Professional representation in all types of civil cases'
        },
        {
          id: 6,
          title: 'Labor Law',
          description: 'Specialized legal solutions for employment and labor matters'
        },
        {
          id: 7,
          title: 'Arbitration & Dispute Resolution',
          description: 'Mediation and arbitration services for amicable conflict resolution'
        },
        {
          id: 8,
          title: 'Debt Collection',
          description: 'Professional legal services for debt recovery and collection'
        }
      ]
    },
    
    // Why Choose Us
    whyUs: {
      title: 'Why Choose Al-Durar',
      subtitle: 'We pride ourselves on delivering exceptional legal services',
      items: [
        {
          id: 1,
          title: 'Professional Legal Expertise',
          description: 'Experienced attorneys with deep knowledge across various legal domains'
        },
        {
          id: 2,
          title: 'Integrity & Confidentiality',
          description: 'We maintain the highest standards of client confidentiality and professional ethics'
        },
        {
          id: 3,
          title: 'Strategic Legal Solutions',
          description: 'Innovative and effective legal strategies that deliver optimal results'
        },
        {
          id: 4,
          title: 'Client-Focused Approach',
          description: 'Continuous case monitoring and regular client communication'
        },
        {
          id: 5,
          title: 'Commitment to Excellence',
          description: 'We strive to exceed client expectations in every engagement'
        }
      ]
    },
    
    // Consultation Form
    consultation: {
      title: 'Book Your Legal Consultation',
      subtitle: 'Fill out the form and we\'ll contact you shortly',
      form: {
        name: 'Full Name',
        phone: 'Phone Number',
        email: 'Email Address',
        service: 'Legal Matter Type',
        message: 'Your Message',
        submit: 'Submit Request',
        selectService: 'Select Service'
      },
      success: 'Your request has been submitted successfully! We\'ll contact you soon.',
      error: 'An error occurred. Please try again.'
    },
    
    // Contact Section
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'re here to help',
      phone: 'Phone',
      email: 'Email',
      location: 'Location',
      hours: 'Business Hours',
      hoursDetail: 'Sunday – Thursday\n8:00 AM – 4:00 PM',
      locationDetail: 'State of Kuwait',
      getInTouch: 'Get In Touch'
    },
    
    // Footer
    footer: {
      description: 'Professional legal services dedicated to protecting your rights and supporting your success.',
      copyright: '© 2026 AL-DURAR LAW FIRM. All Rights Reserved.',
      quickLinks: 'Quick Links'
    }
  }
};

export const firmInfo = {
  name: {
    en: 'AL-DURAR LAW FIRM',
    ar: 'مكتب الدرر للمحاماة والاستشارات القانونية'
  },
  phone: '+965 22066223',
  whatsapp: '+965 66669236',
  email: 'info@aldurarlawfirm.com',
  website: 'www.aldurarlawfirm.com',
  location: {
    en: 'State of Kuwait',
    ar: 'دولة الكويت'
  }
};